import {FC} from 'react'
import {ProductThumb} from '../../../components/common/ProductThumb'
import { IProductReqModel } from '../../products/cors/_models'
import {useIntl} from "react-intl";
import { useLocation } from 'react-router-dom';
type IProps = {
  item: IProductReqModel
  onEdit: (product: IProductReqModel) => void
  canEditRejected: boolean
}

/**
 * Status → coloured badge. Mirrors the standard Metronic chips used
 * elsewhere in the portal (Pending = warning, Catalog Approved =
 * success, Rejected = danger). Better than the raw text we had before.
 */
const STATUS_BADGE: Record<string, {cls: string; key: string}> = {
  pending:           {cls: 'badge-light-warning', key: 'pending'},
  catalog_approved:  {cls: 'badge-light-success', key: 'requests.status.catalog_approved'},
  category_approved: {cls: 'badge-light-success', key: 'requests.status.category_approved'},
  rejected:          {cls: 'badge-light-danger',  key: 'requests.status.rejected'},
  draft_product:     {cls: 'badge-light-secondary', key: 'requests.status.draft'},
}

const AddProductReqTableRow: FC<IProps> = ({item, onEdit, canEditRejected}) => {
  const {formatMessage} = useIntl()
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const statusFilter = urlParams.get('status_filter');

  // `status` is localized by the API (Arabic sessions get 'معلق'/'مرفوض'),
  // so badge and edit logic key off the raw status_code.
  const status = item.status_code || String(item.status ?? '').toLowerCase();
  const badge = STATUS_BADGE[status] ?? {cls: 'badge-light', key: ''};
  const statusLabel = badge.key
    ? formatMessage({id: badge.key, defaultMessage: item.status})
    : (item.status || '—');

  // Pending rows are always editable. Rejected rows are editable on the
  // add-requests page (correct & resubmit); the update-products queue's
  // rejected rows stay frozen — its resubmit path isn't wired yet.
  const isEditable = status === 'pending' || (status === 'rejected' && canEditRejected);

  return (
    <tr>
      <th className='w-100px'>
        <ProductThumb src={item.image} className='table-img' />
      </th>
      <td className='w-200px min-w-200px'>{item.name}</td>
      <td>{item.barcode}</td>
      <td className='text-nowrap'>{item.model}</td>
      <td className='text-nowrap'>{item.supplier_quantity}</td>
      <td className='text-nowrap'>{item.price}</td>
      <td className='text-nowrap'>{item.brand}</td>
      <td className='text-nowrap'>{item.date_added}</td>
      <td className='text-nowrap'>
        <span className={`badge ${badge.cls}`}>{statusLabel}</span>
      </td>

      {statusFilter === 'rejected' && (
        <td className='w-200px min-w-200px' style={{ wordBreak: 'break-word' }}>
          {item.comment}
        </td>
      )}

      <td className='text-nowrap'>
        {isEditable ? (
          <button
            className='btn btn-secondary p-2 px-5 align-self-baseline'
            style={{ textAlign: 'center', width: '100px' }}
            onClick={() => onEdit(item)}
          >
            {formatMessage({ id: 'edit' })}
          </button>
        ) : (
          <span className='text-muted fs-8'>—</span>
        )}
      </td>
    </tr>
  );
};

export default AddProductReqTableRow
